import { CURRENT_STATUS, PDF_LINK } from '@utils/translation'
import React, {
  FC,
  ReactNode,
  createContext,
  useContext,
  useReducer,
} from 'react'

type AmbassadorProviderProps = {
  children?: ReactNode
}
export interface State {
  initialValue: string
  hamburgerClicked: string
  myProfileValue: any
  pdfData: string
  profileSaathi: string
}

const initialState = {
  initialValue: '',
  hamburgerClicked: '',
  pdfData: '',
  myProfileValue: {},
  profileSaathi: '',
}

type Action =
  | {
      type: 'SET_INITIAL_VALUE'
      value: any
    }
  | {
      type: 'SET_HAMBURGER_CLICK'
      value: any
    }
  | {
      type: 'PDF_DATA_UPDATED'
      value: any
    }
  | {
      type: 'MY_PROFILE_DATA'
      value: any
    }
  | {
      type: 'PROFILE_SAATHI'
      value: any
    }

export const AmbassadorContext = createContext<State | any>(initialState)

const AmbassadorReducer = (state: State, action: Action) => {
  const { type, value } = action
  switch (type) {
    case 'SET_INITIAL_VALUE': {
      return {
        ...state,
        initialValue: value,
      }
    }
    case 'SET_HAMBURGER_CLICK': {
      return {
        ...state,
        hamburgerClicked: value,
      }
    }
    case 'PDF_DATA_UPDATED': {
      if (localStorage.getItem(PDF_LINK)) {
        return {
          ...state,
          pdfData: JSON.parse(localStorage.getItem(PDF_LINK) || ''),
        }
      }
      return {
        ...state,
        pdfData: null,
      }
    }
    case 'MY_PROFILE_DATA': {
      if (localStorage.getItem(CURRENT_STATUS)) {
        return {
          ...state,
          myProfileValue: JSON.parse(
            localStorage.getItem(CURRENT_STATUS) || '{}'
          ),
        }
      }
      return {
        ...state,
        myProfileValue: null,
      }
    }
    case 'PROFILE_SAATHI': {
      return {
        ...state,
        profileSaathi: value,
      }
    }
  }
}

export const AmbassadorProvider: FC<AmbassadorProviderProps> = (props) => {
  const [state, dispatch] = useReducer(AmbassadorReducer, initialState)
  const value = {
    ...state,
    dispatch: dispatch,
  }

  return <AmbassadorContext.Provider value={value} {...props} />
}

export const useAmbassadorContext = () => {
  const context = useContext(AmbassadorContext)
  if (context === undefined) {
    throw new Error(`useAmbassdorContext must be used within a UIProvider`)
  }

  return context
}
